"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OptimizedImage;
const react_1 = __importDefault(require("react"));
const image_1 = __importDefault(require("next/image"));
function OptimizedImage({ src, alt, width, height, className = '', priority = false, fill = false, sizes = '100vw', quality = 75, deviceSizes = [640, 1080, 1920], onLoad, unoptimized = false, }) {
    // Check if the source is an SVG
    const isSvg = src.toLowerCase().endsWith('.svg');
    // Use Next.js Image for SVGs, development, or when unoptimized is requested
    if (isSvg || process.env.NODE_ENV === 'development' || unoptimized) {
        return (react_1.default.createElement(image_1.default, { src: src, alt: alt, width: width, height: height, className: className, priority: priority, fill: fill, sizes: sizes, quality: quality, onLoad: onLoad, unoptimized: unoptimized }));
    }
    // In production (and not an SVG), use optimized picture tags with AVIF and WebP
    // Extract path and filename
    const pathParts = src.split('/');
    const filename = pathParts.pop()?.replace(/\.(jpg|jpeg|png|webp|avif)$/i, '') || '';
    const directory = pathParts.join('/');
    const optimizerPath = `${directory}/nextImageExportOptimizer`;
    // Generate srcset for AVIF
    const avifSrcSet = deviceSizes
        .map(size => `${optimizerPath}/${filename}-opt-${size}.AVIF ${size}w`)
        .join(', ');
    // Generate srcset for WebP
    const webpSrcSet = deviceSizes
        .map(size => `${optimizerPath}/${filename}-opt-${size}.WEBP ${size}w`)
        .join(', ');
    // Fallback image
    const fallbackSrc = `${optimizerPath}/${filename}-opt-${deviceSizes[deviceSizes.length - 1]}.WEBP`;
    if (fill) {
        return (react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { type: "image/avif", srcSet: avifSrcSet, sizes: sizes }),
            react_1.default.createElement("source", { type: "image/webp", srcSet: webpSrcSet, sizes: sizes }),
            react_1.default.createElement("img", { src: fallbackSrc, alt: alt, loading: priority ? 'eager' : 'lazy', decoding: "async", className: className, onLoad: onLoad, style: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    color: 'transparent',
                } })));
    }
    return (react_1.default.createElement("picture", null,
        react_1.default.createElement("source", { type: "image/avif", srcSet: avifSrcSet, sizes: sizes }),
        react_1.default.createElement("source", { type: "image/webp", srcSet: webpSrcSet, sizes: sizes }),
        react_1.default.createElement("img", { src: fallbackSrc, alt: alt, width: width, height: height, loading: priority ? 'eager' : 'lazy', decoding: "async", className: className, onLoad: onLoad })));
}
